<app-users-listing [enableMainBtn]="true" [titleMainBtn]="'Aggiungi Docente'" [type]="type"
  [linkMainBtn]="'/nuovo-utente'" [linkMainBtnQueryParams]="{type: type}">
</app-users-listing>